import { Inject, Injectable } from "@angular/core";
import { Device } from "@nms-ng2/app/modules/device/device-backup/device-backup.models";
import { MONITORING_SERVICE, NG_DIALOG } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";

/**
 * Serviço responsável por abrir a modal de seleção de equipamentos.
 */
@Injectable({
    providedIn: "root"
})
export class DeviceModalOpenService {

    constructor(@Inject(MONITORING_SERVICE) private readonly monitoringService: any,
                @Inject(NG_DIALOG) private readonly ngDialog: any) {
        // Construtor intencionalmente vazio
    }

    /**
    * Abre um modal para seleção de equipamentos.
    * @param selectedDevices Equipamentos já selecionados.
    * @param callback Função de callback a ser chamada com os equipamentos selecionados.
    * @param allowOnlyOneEquipment Indica se apenas um equipamento pode ser selecionado.
    * @param allowOnlyPolledEquipment Indica se apenas equipamentos com polling finalizados podem ser selecionados.
    */
    openDevicesModal(selectedDevices: Device[], callback: Function, allowOnlyOneEquipment: boolean = false,
        allowOnlyPolledEquipment: boolean = false): Promise<void> {

        const validDevicesAlreadyAdded = Array.isArray(selectedDevices) && (selectedDevices.length > 0)
            ? selectedDevices.filter(device => device != null)
            : [];

        return this.ngDialog
            .openConfirm({
                template: "templates/features/template/template-instance/modals/add-device-modal.html",
                controller: "AddDeviceModalGenericCtrl",
                className: "extra-large-modal",
                closeByNavigation: true,
                resolve: {
                    devicesAlreadyAdded: () => validDevicesAlreadyAdded,
                    deviceModelRestrictionTypes: () => {},
                    monitoringSettings: () => this.monitoringService.getMonitoringSettings(),
                    allowOnlyOneEquipment: () => allowOnlyOneEquipment,
                    allowOnlyPolledEquipment: () => allowOnlyPolledEquipment
                }
            })
            .then((selectedDevices: Device[]) => {
                if (allowOnlyOneEquipment) {
                    return callback(selectedDevices[0]);
                }
                return callback(selectedDevices);
            })
            .catch((error: any) => {
                return [];
            });
    }

}
